import { defineComponent as _defineComponent } from 'vue'
import LfBlueTitleComponent from '@/components/HeaderTitle/LfBlueTitleComponent.vue'
import { useI18n } from 'vue-i18n-composable'
import LfActionsBarComponent from '@/components/ActionsBar/LfActionsBarComponent.vue'
import { computed, onMounted } from 'vue'
import { LabelButtonVariant } from '@/components/forms/buttons/types/ButtonTypes'
import { ActionName } from '@/components/ActionsBar/types/ActionBarComponentTypes'
import { inject } from 'vue'
import { createLink } from '@/helpers/blob'
import {
  useImportExpedientsProcessStore
} from '@/views/Expedients/components/ImportExpedientsDialog/stores/useImportExpedientsProcessStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'ImportExpedientsSummaryComponent',
  setup(__props) {

const closeDialog = inject('closeDialog') as () => void
const resetStep = inject('resetStep') as () => void

// @note: no se desestructura para mantener la reactividad y el estado definido en el componente padre
const importExpedientsProcessStore = useImportExpedientsProcessStore()

const { t } = useI18n()
const TEXT = {
  title: t('components.expedient_import_dialog.title').toString(),
  importFinished: t('components.expedient_import_dialog.summary.import_finished').toString(),
  createdRecords: t('components.expedient_import_dialog.summary.created_records').toString(),
  errorRecords: t('components.expedient_import_dialog.summary.error_records').toString(),
  failedInfo: t('components.expedient_import_dialog.summary.failed_info').toString(),
  close: t('action_buttons.close').toString(),
  newImport: t('action_buttons.new_import').toString(),
  downloadFailedRecords: t('components.expedient_import_dialog.summary.download_failed_records').toString(),
  failureFileName: t('components.expedient_import_dialog.summary.failure_file_name').toString(),
  technicalError: t('components.expedient_import_dialog.summary.technical_error').toString(),
}
const buttons = computed(() => {
  return [
    {
      tooltip: TEXT.newImport,
      variant: LabelButtonVariant.OUTLINED,
      action: ActionName.NEW,
      enabled: true
    },
    {
      tooltip: TEXT.close,
      variant: LabelButtonVariant.SOLID,
      action: ActionName.CLOSE,
      enabled: true
    }
  ]
})

const showFailureLink = computed(():boolean => {
  return importExpedientsProcessStore.hasFailures
})

const showTecnicalError = computed(():boolean => {
  return importExpedientsProcessStore.hasSummaryError
})

function onExecuteAction(action: string ) {
  switch (action) {
    case ActionName.NEW:
      importExpedientsProcessStore.init()
      resetStep()
      return
    case ActionName.CLOSE:
      closeDialog()
      return
    case ActionName.DOWNLOAD:
      downloadFailureImportExpedientFile()
      return
  }
}

// Función para descargar fichero de errores
async function downloadFailureImportExpedientFile() {
  try {
    const failureFail = await importExpedientsProcessStore.downloadFailureImportExpedientsFile()
    createLink(failureFail.downloadUrl, TEXT.failureFileName)
  } catch (error) {
    console.error('ERROR download failure file', error)
  }
}

return { __sfc: true,closeDialog, resetStep, importExpedientsProcessStore, t, TEXT, buttons, showFailureLink, showTecnicalError, onExecuteAction, downloadFailureImportExpedientFile, LfBlueTitleComponent, LfActionsBarComponent, ActionName }
}

})